import get from 'lodash/get';

export const validateData = (data, rules) => {
  const errors = {};
  rules.forEach(rule => {
    const value = get(data, rule.field);
    const isEmpty = value === undefined || value === null || (typeof value === 'string' && value.trim() === '');
    if (rule.required && isEmpty) {
      errors[rule.field] = rule.message || `${rule.field} is required`;
      return;
    }
    if (typeof value === 'string' && value.trim().length > 0) {
      if (rule.minLength && value.length < rule.minLength) {
        errors[rule.field] = rule.message || `Minimum length is ${rule.minLength}`;
      } else if (rule.maxLength && value.length > rule.maxLength) {
        errors[rule.field] = rule.message || `Maximum length is ${rule.maxLength}`;
      }
    }
  });
  return errors;
};